"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createClinicalKeywordsMachine = void 0;
const xstate_1 = require("xstate");
const axios_1 = __importDefault(require("axios"));
const uniqBy_1 = __importDefault(require("lodash/uniqBy"));
const typings_1 = require("./typings");
const assertEventType_1 = require("../../../../common/util/assertEventType");
const urls_1 = require("../../../api/urls");
const types_1 = require("../../../../types");
const headers_1 = require("../../../api/headers");
const NOOP = () => {
    // no operation
};
const createClinicalKeywordsMachine = (initialContext) => (0, xstate_1.Machine)({
    id: 'clinical-keywords',
    initial: typings_1.ClinicalKeywordsStates.INIT,
    context: Object.assign({ clinicalKeywords: [], version: types_1.SEARCH_API_VERSION.V9 }, initialContext),
    states: {
        [typings_1.ClinicalKeywordsStates.INIT]: {
            always: [
                {
                    target: typings_1.ClinicalKeywordsStates.LOADING_CLINICAL_KEYWORDS,
                    cond: 'noClinicalKeywords'
                },
                { target: typings_1.ClinicalKeywordsStates.IDLE }
            ]
        },
        [typings_1.ClinicalKeywordsStates.IDLE]: {
            id: typings_1.ClinicalKeywordsStates.IDLE,
            type: 'final'
        },
        [typings_1.ClinicalKeywordsStates.LOADING_CLINICAL_KEYWORDS]: {
            invoke: {
                id: 'fetchClinicalKeywords',
                src: 'fetchClinicalKeywords',
                onDone: {
                    target: typings_1.ClinicalKeywordsStates.LOAD_CLINICAL_KEYWORDS_SUCCESS,
                    actions: ['setClinicalKeywords', 'onFetchSuccess']
                },
                onError: {
                    target: typings_1.ClinicalKeywordsStates.LOAD_CLINICAL_KEYWORDS_FAILURE,
                    actions: ['onFetchError']
                }
            }
        },
        [typings_1.ClinicalKeywordsStates.LOAD_CLINICAL_KEYWORDS_SUCCESS]: {
            always: typings_1.ClinicalKeywordsStates.IDLE
        },
        [typings_1.ClinicalKeywordsStates.LOAD_CLINICAL_KEYWORDS_FAILURE]: {
            on: {
                [typings_1.ClinicalKeywordsEventType.FETCH_CLINICAL_KEYWORDS]: {
                    target: typings_1.ClinicalKeywordsStates.LOADING_CLINICAL_KEYWORDS
                }
            }
        }
    }
}, {
    guards: {
        noClinicalKeywords: (context) => {
            return !context.clinicalKeywords.length;
        }
    },
    actions: {
        setClinicalKeywords: (0, xstate_1.assign)({
            clinicalKeywords: (_, event) => {
                (0, assertEventType_1.assertEventType)(event, typings_1.ClinicalKeywordsEventType.DONE_INVOKE_FETCH_CLINICAL_KEYWORDS);
                return event.data;
            }
        }),
        onFetchSuccess: NOOP,
        onFetchError: NOOP
    },
    services: {
        fetchClinicalKeywords: (context) => __awaiter(void 0, void 0, void 0, function* () {
            if (context.version === types_1.SEARCH_API_VERSION.V9) {
                const results = yield axios_1.default.get(urls_1.URLS.clinical_keywords(context.customerCode, context.provider.id), {
                    headers: (0, headers_1.buildHeaders)(context.customerCode, context.productName)
                });
                const { provider } = results.data;
                const clinicalKeywords = (0, uniqBy_1.default)([
                    ...provider.clinical_keywords.promoted,
                    ...provider.clinical_keywords.searchable.flatMap((v) => [v, ...(v.terms || [])])
                ], 'name');
                return clinicalKeywords;
            }
            else if (context.version === types_1.SEARCH_API_VERSION.V8) {
                const results = yield axios_1.default.get(urls_1.URLS.scope_of_practice(context.customerCode, context.provider.id), {
                    headers: (0, headers_1.buildHeaders)(context.customerCode, context.productName)
                });
                const payload = results.data;
                // parse payload into flat array
                const { scope_of_practice: ScopeOfPractice } = payload;
                const clinicalKeywords = ScopeOfPractice.concepts.reduce((keywords, concept) => {
                    // grab all the terms under each concept
                    const terms = concept.terms.map((term) => ({
                        cui: term.tui,
                        name: term.name
                    }));
                    return [
                        ...keywords,
                        { name: concept.name, cui: concept.cui },
                        ...terms
                    ];
                }, []);
                return (0, uniqBy_1.default)(clinicalKeywords, 'name');
            }
            throw new Error(`Unexpected search api version: ${context.version}, supported versions are ${Object.values(types_1.SEARCH_API_VERSION).join(', ')}`);
        })
    }
});
exports.createClinicalKeywordsMachine = createClinicalKeywordsMachine;
//# sourceMappingURL=createClinicalKeywordsMachine.js.map